import type { Database } from "./database";

export type Tables<T extends keyof Database["public"]["Tables"]> = Database["public"]["Tables"][T]["Row"];
export type Insert<T extends keyof Database["public"]["Tables"]> = Database["public"]["Tables"][T]["Insert"];
export type Update<T extends keyof Database["public"]["Tables"]> = Database["public"]["Tables"][T]["Update"];
export type Enums<T extends keyof Database["public"]["Enums"]> = Database["public"]["Enums"][T];

export type Client = Tables<"clients">;
export type Contact = Tables<"contacts">;
export type Product = Tables<"products">;
export type ClientPrice = Tables<"client_prices">;
export type Activity = Tables<"activities">;
export type Task = Tables<"tasks">;
export type CustomFieldDefinition = Tables<"custom_field_definitions">;

export const CLIENT_STATUS_LABEL: Record<Enums<"client_status">, string> = {
  active: "Actif", suspended: "Suspendu", closed: "Fermé",
};
export const DELIVERY_CHANNEL_LABEL: Record<Enums<"delivery_channel">, string> = {
  airtable: "Airtable", telegram: "Telegram", whatsapp: "WhatsApp", email: "Email", api: "API", manual: "Manuel",
};
export const ACTIVITY_TYPE_LABEL: Record<Enums<"activity_type">, string> = {
  note: "Note", call: "Appel", email: "Email", meeting: "Réunion", status_change: "Changement de statut", system: "Système",
};
